<template>
  <div class="entry-wrapper">
    <!-- Run v-for on every result object -->
    <!-- Add event listeners for object pop-up on hover -->
    <!-- lessThan974 checks window width to conditionally apply mouse events -->
    <div
      class="entry-container"
      v-for="(result, index) in results"
      :key="result.imagePath"
      :class="`entry-${index + 1}`"
      v-on="
        lessThan974
          ? {}
          : {
              mouseover: () => hoverHandler('over', index),
              mouseleave: () => hoverHandler('leave', index),
            }
      "
    >
      <div class="entry">
        <div class="entry-image-wrapper">
          <img class="entry-image" :src="result.imagePath" />
        </div>
        <!-- On hover, show the appropriate pop-up -->
        <!-- Always show "pop-up" if lessThan974 is true (smaller screens) -->
        <div
          class="entry-details"
          v-show="(!lessThan974 && hover && show === index) || lessThan974"
        >
          <!-- Hide image link if lessThan974 is true (smaller screens) -->
          <router-link
            class="entry-details-img-wrapper"
            v-if="!lessThan974"
            :to="{
              name: 'database-item',
              params: {
                pathMatch: result.dbUid.split('/').slice(1),
                language: result.languageId
              },
            }"
          >
            <img :src="result.imagePath" />
          </router-link>
          <div class="entry-text-container">
            <p class="entry-name" v-html="result.name"></p>
            <p class="entry-date" v-html="result.objectDate"></p>
            <p class="entry-partner">{{ result.partnerName }}</p>
            <p class="entry-location">
              {{ result.location }}, {{ result.countryName }}
            </p>
            <p class="entry-project">
              for <span>{{ result.projectName }}</span>
            </p>
            <router-link
              class="entry-details-img-wrapper"
              :to="{
                name: 'database-item',
                params: {
                  pathMatch: result.dbUid.split('/').slice(1),
                  language: result.languageId
                },
              }"
            >
              <p class="entry-link">See Database Entry &gt;</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import media from "../mixins/media.js";
export default {
  name: "ObjectGrid",
  mixins: [media],
  props: ["results"],
  data() {
    return {
      hover: false,
      show: -1,
      lessThan974: window.matchMedia("(max-width: 974px)").matches,
    }
  }
};
</script>



<style scoped lang="scss">
.entry-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

.entry {
  @include flex-center;
  position: relative;
  height: 175px;
}
.entry-image-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.entry-image {
  @include image-scale;
  object-fit: contain;
  border: 1px solid $background-color;
}
.entry-details {
  @include flex-center;
  flex-direction: column;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 50;
  background-color: $background-color;
  font-size: 95%;
  box-shadow: 2px 2px 5px $shadow-grey;
}
.entry-details a {
  width: 100%;
}
.entry-details img {
  @include image-scale;
  height: 175px;
  object-fit: contain;
}
.entry-text-container {
  width: 100%;
  padding: 10px 10px 0 10px;
}
.entry-text-container a {
  display: block;
}
.entry-name,
.entry-partner {
  font-weight: bold;
}
.entry-date {
  margin-bottom: 10px;
}
.entry-project span {
  font-weight: bold;
  font-style: italic;
}
.entry-link {
  @include link-styles;
  padding: 10px 0;
}

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #collection-results {
    display: -ms-grid;
    -ms-grid-columns: 1fr 15px 1fr 15px 1fr 15px 1fr;
  }
  .entry-1,
  .entry-5,
  .entry-9,
  .entry-13,
  .entry-17 {
    -ms-grid-column: 1;
  }
  .entry-2,
  .entry-6,
  .entry-10,
  .entry-14,
  .entry-18 {
    -ms-grid-column: 3;
  }
  .entry-3,
  .entry-7,
  .entry-11,
  .entry-15,
  .entry-19 {
    -ms-grid-column: 5;
  }
  .entry-4,
  .entry-8,
  .entry-12,
  .entry-16,
  .entry-20 {
    -ms-grid-column: 7;
  }
  .entry-1,
  .entry-2,
  .entry-3,
  .entry-4 {
    -ms-grid-row: 1;
  }
  .entry-5,
  .entry-6,
  .entry-7,
  .entry-8 {
    -ms-grid-row: 2;
  }
  .entry-9,
  .entry-10,
  .entry-11,
  .entry-12 {
    -ms-grid-row: 3;
  }
  .entry-13,
  .entry-14,
  .entry-15,
  .entry-16 {
    -ms-grid-row: 4;
  }
  .entry-17,
  .entry-18,
  .entry-19,
  .entry-20 {
    -ms-grid-row: 5;
  }
  .entry-1,
  .entry-2,
  .entry-3,
  .entry-4,
  .entry-5,
  .entry-6,
  .entry-7,
  .entry-8,
  .entry-9,
  .entry-10,
  .entry-11,
  .entry-12,
  .entry-13,
  .entry-14,
  .entry-15,
  .entry-16,
  .entry-17,
  .entry-18,
  .entry-19,
  .entry-20 {
    margin-bottom: 15px;
  }
  .entry {
    width: 100%;
    border: 1px solid $background-color;
  }
  .entry-image,
  .entry-details img {
    max-height: 100%;
    max-width: 100%;
    height: auto;
    width: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border: 1px solid transparent;
  }
  .entry-details-img-wrapper {
    position: relative;
    height: 175px;
    border: 1px solid $background-color;
  }
}

@media only screen and (max-width: 974px) {
  .entry-wrapper {
    @include flex-center;
    flex-direction: column;
    align-items: flex-start;
  }

  .entry-container {
    width: 100%;
  }
  .entry {
    height: 150px;
    width: 100%;
    margin-bottom: 20px;
  }
  .entry-image-wrapper {
    width: 38%;
  }
  .entry-image {
    width: 100%;
  }
  .entry-details {
    justify-content: flex-start;
    position: static;
    height: 100%;
    width: 62%;
    background-color: white;
    box-shadow: none;
    padding-left: 20px;
  }
  .entry-text-container {
    padding: 0;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 974px),
  (-ms-high-contrast: active) and (max-width: 974px) {
  .entry {
    border: 1px solid transparent;
  }
  .entry-image-wrapper {
    border: 1px solid $background-color;
  }
  .entry-image {
    width: auto;
  }
}

@media only screen and (max-width: 849px) {
  .entry {
    height: 200px;
  }
}

@media only screen and (max-width: 599px) {
  .entry-image-wrapper {
    width: 30%;
  }
  .entry-details {
    width: 70%;
  }
}

@media only screen and (max-width: 499px) {
  .entry {
    flex-direction: column;
    height: 325px;
    margin-bottom: 10px;
  }
  .entry-image-wrapper {
    height: 45%;
    width: 100%;
  }
  .entry-image {
    height: 100%;
    width: 100%;
  }
  .entry-details {
    height: 55%;
    width: 100%;
    margin-top: 10px;
    padding-left: 0;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 499px),
  (-ms-high-contrast: active) and (max-width: 499px) {
  .entry-image {
    height: auto;
    width: auto;
  }
}

@media only screen and (max-width: 399px) {
  .entry {
    height: 350px;
  }
  .entry-image-wrapper {
    height: 40%;
  }
  .entry-image {
    height: 100%;
  }
  .entry-details {
    height: 60%;
  }
}
</style>